module.exports = __webpack_public_path__ + "static/media/sun.cfcd47c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tangible/sun.png
// module id = 735
// module chunks = 0